// Loads reCAPTCHA only when a form with a `.g-recaptcha` widget is touched or nears the viewport,
// then renders every widget through the explicit API. Pages whose form is never reached load none of it.
// Each rendered widget keeps its id in `data-widget-id`, so form scripts can call `grecaptcha.reset(id)`.
const SELECTOR = '.g-recaptcha'
const CALLBACK = 'onRecaptchaLoad'
const EVENTS = ['focusin', 'input', 'pointerdown', 'submit']

let requested = false
let observer = null

function render() {
	document.querySelectorAll(SELECTOR).forEach((el) => {
		if (el.dataset.widgetId !== undefined || el.childElementCount) {
			return
		}

		el.dataset.widgetId = window.grecaptcha.render(el, {
			sitekey: el.dataset.sitekey,
		})
	})
}

function stop() {
	EVENTS.forEach((type) => document.removeEventListener(type, onEvent, true))

	if (observer) {
		observer.disconnect()
	}
}

function load() {
	if (requested) {
		return
	}

	requested = true
	stop()

	// a template that still includes api.js itself auto-renders its widgets
	if (
		window.grecaptcha ||
		document.querySelector('script[src*="/recaptcha/api.js"]')
	) {
		return
	}

	window[CALLBACK] = render

	const script = document.createElement('script')
	script.src = `https://www.google.com/recaptcha/api.js?onload=${CALLBACK}&render=explicit`
	script.async = true
	document.head.appendChild(script)
}

// a submit before the widget renders posts no token, which the server rejects like an unticked box
function onEvent(e) {
	const form = e.target instanceof Element ? e.target.closest('form') : null

	if (form && form.querySelector(SELECTOR)) {
		load()
	}
}

function observe() {
	const widgets = document.querySelectorAll(SELECTOR)

	if (!widgets.length || requested) {
		return
	}

	if (!('IntersectionObserver' in window)) {
		load()
		return
	}

	observer = new IntersectionObserver(
		(entries) => entries.some((entry) => entry.isIntersecting) && load(),
		{
			rootMargin: '200px',
		},
	)

	// the empty widget has no height before it renders, so watch its form; a closed lightbox never intersects
	widgets.forEach((el) => observer.observe(el.closest('form') || el))
}

EVENTS.forEach((type) => document.addEventListener(type, onEvent, true))

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', observe)
} else {
	observe()
}
